module.exports = __webpack_public_path__ + "static/media/Quantum.0cacdb9b.jpg";